import { useEffect, useState } from 'react';
import { getActiveCall, onActiveCallChange, type ActiveCallContext } from '@/domain/callFlow';

export function useActiveCall() {
  const [call, setCall] = useState<ActiveCallContext | null>(getActiveCall());
  useEffect(() => onActiveCallChange(setCall), []);
  return call;
}
